var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"order-list"},[_c('Orders',{ref:"orders",attrs:{"type":_vm.type,"isSingle":_vm.isSingle},on:{"totalCount":_vm.getTotalCount}}),_vm._v(" "),(_vm.totalCount == 0 && !_vm.havKeyword)?_c('Empty',{staticClass:"empty-content",attrs:{"isSingle":_vm.isSingle}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d96b21","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/merchantOrders/list/List.vue
// module id = null
// module chunks = 